<template>
    <div class="container">
        <div class="h-[calc(100vh-8rem)] flex items-center justify-center">
            <div class="text-center pt-32 pb-32 my-8 rounded-2xl flex justify-center flex-col items-center">
                <div class="waving-hand-emoji mb-4"></div>
                <div class="flex flex-col items-center">
                    <span class="text-xl lg:text-2xl block mb-3 font-Inter-Bold"
                        >{{ $t('career.no_positions_title') }}</span
                    >
                </div>
                <div class="flex flex-col items-center">
                    <span class="text-sm lg:text-base font-Inter-Regular block"
                        >{{ $t('career.no_positions_text_1') }}<br />
                        {{ $t('career.no_positions_text_2') }}</span
                    >
                </div>
                <PButton :label="$t('errors.back_to_homepage')" class="mt-8" :to="localePath('/')" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Career',
};
</script>
